/**
 * Variant Search Filter
 * 
 * Filtra variantes em tempo real baseado no texto de busca
 */

(function() {
  'use strict';

  // Normalizar texto para comparação (remover acentos, lowercase)
  function normalizeText(text) {
    return text
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
      .trim();
  }

  // Buscar texto em variante
  function searchInVariant(variantElement, searchTerm) {
    if (!variantElement) return false;
    
    const searchText = normalizeText(searchTerm);
    if (!searchText) return true; // Se busca vazia, mostrar tudo
    
    // Buscar no label diretamente
    const label = variantElement.tagName === 'LABEL' ? variantElement : variantElement.querySelector('label');
    if (!label) return false;

    // Buscar em todos os textos da variante
    const flavorItems = label.querySelectorAll('.variant-flavor-item');
    const singleFlavorText = label.querySelector('.variant-single-flavor-text');
    
    // Buscar em itens de sabor múltiplo
    for (const item of flavorItems) {
      const itemText = normalizeText(item.textContent || '');
      if (itemText.includes(searchText)) {
        return true;
      }
    }
    
    // Buscar em sabor único
    if (singleFlavorText) {
      const text = normalizeText(singleFlavorText.textContent || '');
      if (text.includes(searchText)) {
        return true;
      }
    }
    
    // Buscar também no texto completo do label como fallback
    const labelText = normalizeText(label.textContent || '');
    if (labelText.includes(searchText)) {
      return true;
    }
    
    return false;
  }

  // Filtrar variantes
  function filterVariants(searchTerm, fieldset) {
    if (!fieldset) return { visible: 0, total: 0 };
    
    const inputs = fieldset.querySelectorAll('input[type="radio"]');
    let visibleCount = 0;
    const totalCount = inputs.length;

    inputs.forEach(input => {
      const label = fieldset.querySelector(`label[for="${input.id}"]`);
      if (!label) return;

      // O label é o próprio card
      const variantCard = label;
      
      if (!searchTerm || searchTerm.trim() === '') {
        // Mostrar todas se busca vazia
        variantCard.style.removeProperty('display');
        visibleCount++;
      } else {
        // Filtrar baseado no termo de busca
        const matches = searchInVariant(variantCard, searchTerm);
        if (matches) {
          variantCard.style.removeProperty('display');
          visibleCount++;
        } else {
          variantCard.style.setProperty('display', 'none', 'important');
        }
      }
    });

    return { visible: visibleCount, total: totalCount };
  }

  // Atualizar contador de resultados
  function updateResultsCount(resultsElement, countElement, visible, total) {
    if (!resultsElement || !countElement) return;

    if (visible === total) {
      resultsElement.style.display = 'none';
    } else {
      resultsElement.style.display = 'block';
      // Textos traduzidos vêm do snippet variant-search.liquid (data-variant-search-label-one/other),
      // com [count] = visíveis e [total] = total; o JS nunca tem texto fixo.
      const template = (visible === 1
        ? countElement.dataset.variantSearchLabelOne
        : countElement.dataset.variantSearchLabelOther) || '[count] / [total]';
      countElement.textContent = template.replace('[count]', visible).replace('[total]', total);
    }
  }

  // Função para executar busca
  function executeSearch(searchInput, fieldset, resultsElement, countElement, clearButton) {
    if (!searchInput || !fieldset) return;
    
    const searchTerm = searchInput.value;
    
    // Filtrar variantes
    const results = filterVariants(searchTerm, fieldset);
    updateResultsCount(resultsElement, countElement, results.visible, results.total);
    
    // Mostrar/ocultar botão limpar
    if (clearButton) {
      clearButton.style.display = searchTerm.trim() ? 'flex' : 'none';
    }
  }

  // Obter elementos do wrapper
  function getSearchElements(wrapper) {
    const searchInput = wrapper.querySelector('[data-variant-search-input]');
    const clearButton = wrapper.querySelector('[data-variant-search-clear]');
    const resultsElement = wrapper.querySelector('[data-variant-search-results]');
    const countElement = wrapper.querySelector('[data-variant-search-count]');
    
    let fieldset = wrapper.closest('.product-form__input--pill');
    if (!fieldset) {
      const variantSelects = wrapper.closest('variant-selects');
      if (variantSelects) {
        fieldset = variantSelects.querySelector('.product-form__input--pill');
      }
    }

    return { searchInput, clearButton, resultsElement, countElement, fieldset };
  }

  // Usar event delegation no document para garantir que sempre funcione
  document.addEventListener('input', (e) => {
    const searchInput = e.target.closest('[data-variant-search-input]');
    if (!searchInput) return;
    
    const wrapper = searchInput.closest('[data-variant-search-wrapper]');
    if (!wrapper) return;

    const { fieldset, resultsElement, countElement, clearButton } = getSearchElements(wrapper);
    if (!fieldset) return;

    executeSearch(searchInput, fieldset, resultsElement, countElement, clearButton);
  }, true);

  document.addEventListener('keyup', (e) => {
    const searchInput = e.target.closest('[data-variant-search-input]');
    if (!searchInput) return;
    
    if (e.key === 'Enter' || e.keyCode === 13) return;

    const wrapper = searchInput.closest('[data-variant-search-wrapper]');
    if (!wrapper) return;

    const { fieldset, resultsElement, countElement, clearButton } = getSearchElements(wrapper);
    if (!fieldset) return;

    executeSearch(searchInput, fieldset, resultsElement, countElement, clearButton);
  }, true);

  document.addEventListener('paste', (e) => {
    const searchInput = e.target.closest('[data-variant-search-input]');
    if (!searchInput) return;
    
    const wrapper = searchInput.closest('[data-variant-search-wrapper]');
    if (!wrapper) return;

    const { fieldset, resultsElement, countElement, clearButton } = getSearchElements(wrapper);
    if (!fieldset) return;

    setTimeout(() => {
      executeSearch(searchInput, fieldset, resultsElement, countElement, clearButton);
    }, 10);
  }, true);

  // Prevenir submit do formulário ao pressionar Enter
  document.addEventListener('keydown', (e) => {
    const searchInput = e.target.closest('[data-variant-search-input]');
    if (!searchInput) return;

    if (e.key === 'Enter' || e.keyCode === 13) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      return false;
    }
  }, true);

  // Botão limpar - event delegation
  document.addEventListener('click', (e) => {
    const clearButton = e.target.closest('[data-variant-search-clear]');
    if (!clearButton) return;

    e.preventDefault();
    e.stopPropagation();

    const wrapper = clearButton.closest('[data-variant-search-wrapper]');
    if (!wrapper) return;

    const { searchInput, fieldset, resultsElement, countElement } = getSearchElements(wrapper);
    if (!searchInput || !fieldset) return;

    searchInput.value = '';
    searchInput.focus();
    executeSearch(searchInput, fieldset, resultsElement, countElement, clearButton);
  }, true);

  // Prevenir submit do form
  document.addEventListener('submit', (e) => {
    const searchInput = e.target.querySelector('[data-variant-search-input]');
    if (!searchInput) return;
    
    if (document.activeElement === searchInput || searchInput.value.trim() !== '') {
      e.preventDefault();
      e.stopPropagation();
      return false;
    }
  }, true);
})();